import CommoditySelector from './commodity-selector.vue';

export default {
  install(application) {
    application.component('yx-commodity-selector', CommoditySelector);
  },
};
